import { hasFeature } from '@/services/featureService';
import { Feature } from '@/utils/constant';

/**
 * Shared gate for Include Home Inspection UI + Save path (issue #420).
 * Matches product AC: module + create flags. PS create page already implies service access.
 * API HI create is flag-gated only (no team membership check).
 */
export const canCreateLinkedHomeInspection = (): boolean =>
  hasFeature(Feature.HOME_INSPECTION) && hasFeature(Feature.HOME_INSPECTION_WORK_ORDER_CREATE);
